export default "__VITE_ASSET__DMMuIG56__"